// extracted by mini-css-extract-plugin
export default {"school__name":"mapView_school__name__Z+7dl","limit-text":"mapView_limit-text__2VfVb","popup-title":"mapView_popup-title__ABMeW"};